class HelpersService {
  diff(obj1, obj2) {
    const result = {};
    if (Object.is(obj1, obj2)) {
        return undefined;
    }
    if (!obj2 || typeof obj2 !== 'object') {
        return obj2;
    }
    Object.keys(obj1 || {}).concat(Object.keys(obj2 || {})).forEach(key => {
        if(obj2[key] !== obj1[key] && !Object.is(obj1[key], obj2[key])) {
            result[key] = obj2[key];
        }
        if(typeof obj2[key] === 'object' && typeof obj1[key] === 'object') {
            const value = this.diff(obj1[key], obj2[key]);
            if (value !== undefined) {
                result[key] = value;
            }
        }
    });
    return result;
  }

  clone(obj){
    //in case of premitives
    if(obj===null || typeof obj !== "object"){
      return obj;
    }
  
    //date objects should be 
    if(obj instanceof Date){
      return new Date(obj.getTime());
    }
  
    //handle Array
    if(Array.isArray(obj)){
      var clonedArr = [];
      obj.forEach((element) => {
        clonedArr.push(this.clone(element))
      });
      return clonedArr;
    }
  
    //lastly, handle objects
    let clonedObj = new obj.constructor();
    for(var prop in obj){
      if(obj.hasOwnProperty(prop)){
        clonedObj[prop] = this.clone(obj[prop]);
      }
    }
    return clonedObj;
  }
}

export const helpersSvc = new HelpersService();